export default __webpack_public_path__ + "static/media/2_HR912C_retouche-min.178b075a.jpg";